import { BuiltInPlan } from "../../lib/workout";

export default {
  id: "e81a807f-0e3d-47c4-8d63-9cfc1b948174",
  title: "Couch to 5K",
  raceType: "5K",
  units: "kilometers",
  workouts: [
    {
      description: "Rest",
      totalDistance: 0,
    },
    {
      description: "Run 30 seconds, walk 30 seconds. Repeat 15 times",
      totalDistance: 0,
    },
    {
      description: "Rest",
      totalDistance: 0,
    },
    {
      description: "Run/walk 10 minutes",
      totalDistance: 0,
    },
    {
      description: "Rest",
      totalDistance: 0,
    },
    {
      description: "Walk 5 kilometers",
      totalDistance: 0,
    },
    {
      description: "Rest",
      totalDistance: 0,
    },

    {
      description: "Rest",
      totalDistance: 0,
    },
    {
      description: "Run 45 seconds, walk 45 seconds. Repeat 12 times",
      totalDistance: 0,
    },
    {
      description: "Rest",
      totalDistance: 0,
    },
    {
      description: "Run/walk 15 minutes",
      totalDistance: 0,
    },
    {
      description: "Rest",
      totalDistance: 0,
    },
    {
      description: "Walk 5 kilometers (aim to beat previous week's time)",
      totalDistance: 0,
    },
    {
      description: "Rest",
      totalDistance: 0,
    },

    {
      description: "Rest",
      totalDistance: 0,
    },
    {
      description: "Run 60 seconds, walk 60 seconds. Repeat 10 times",
      totalDistance: 0,
    },
    {
      description: "Rest",
      totalDistance: 0,
    },
    {
      description: "Run/walk 20 minutes",
      totalDistance: 0,
    },
    {
      description: "Rest",
      totalDistance: 0,
    },
    {
      description: "Walk 5 kilometers (aim to beat previous week's time)",
      totalDistance: 0,
    },
    {
      description: "Rest",
      totalDistance: 0,
    },

    {
      description: "Rest",
      totalDistance: 0,
    },
    {
      description: "Run 90 seconds, walk 90 seconds. Repeat 8 times",
      totalDistance: 0,
    },
    {
      description: "Rest",
      totalDistance: 0,
    },
    {
      description: "Run/walk 25 minutes",
      totalDistance: 0,
    },
    {
      description: "Rest",
      totalDistance: 0,
    },
    {
      description: "Run 1 kilometers, walk 4 kilometers",
      totalDistance: 0,
    },
    {
      description: "Rest",
      totalDistance: 0,
    },

    {
      description: "Rest",
      totalDistance: 0,
    },
    {
      description: "Run 2 minutes, walk 2 minutes. Repeat 6 times",
      totalDistance: 0,
    },
    {
      description: "Rest",
      totalDistance: 0,
    },
    {
      description: "Run/walk 30 minutes",
      totalDistance: 0,
    },
    {
      description: "Rest",
      totalDistance: 0,
    },
    {
      description: "Run 2 kilometers, walk 3 kilometers",
      totalDistance: 0,
    },
    {
      description: "Rest",
      totalDistance: 0,
    },

    {
      description: "Rest",
      totalDistance: 0,
    },
    {
      description: "Run 3 minutes, walk 2 minutes. Repeat 5 times",
      totalDistance: 0,
    },
    {
      description: "Rest",
      totalDistance: 0,
    },
    {
      description: "Run/walk 35 minutes",
      totalDistance: 0,
    },
    {
      description: "Rest",
      totalDistance: 0,
    },
    {
      description: "Run 3 kilometers, walk 2 kilometers",
      totalDistance: 0,
    },
    {
      description: "Rest",
      totalDistance: 0,
    },

    {
      description: "Rest",
      totalDistance: 0,
    },
    {
      description: "Run 5 minutes, walk 2 minutes. Repeat 4 times",
      totalDistance: 0,
    },
    {
      description: "Rest",
      totalDistance: 0,
    },
    {
      description: "Run/walk 40 minutes",
      totalDistance: 0,
    },
    {
      description: "Rest",
      totalDistance: 0,
    },
    {
      description: "Run 4 kilometers, walk 1 kilometers",
      totalDistance: 0,
    },
    {
      description: "Rest",
      totalDistance: 0,
    },

    {
      description: "Rest",
      totalDistance: 0,
    },
    {
      description: "Run 10 minutes, walk 60 seconds. Repeat 3 times",
      totalDistance: 0,
    },
    {
      description: "Rest",
      totalDistance: 0,
    },
    {
      description: "Run/walk 45 minutes",
      totalDistance: 0,
    },
    {
      description: "Rest",
      totalDistance: 0,
    },
    {
      description: "Rest",
      totalDistance: 0,
    },
    {
      description: "Race Day! Run 5K!",
      totalDistance: 0,
    },
  ],
} as BuiltInPlan